import { render, staticRenderFns } from "./PrivacyPolicyEn.vue?vue&type=template&id=07056a61"
import script from "./PrivacyPolicyEn.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyEn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports